export default __webpack_public_path__ + "static/media/Q-2U-HYBRID-REAR.02feb165.png";